import React, { useState, useEffect } from 'react';
import NavMenu from './NavMenu/NavMenu';
import logo_1 from '../images/logo-2.png';
import logo_2 from '../images/logo-2.png';
import './navBar.css';

const NavBar = () => {
  const [isActive, setIsActive] = useState(false);
  const [scroll, setScroll] = useState(false);

  const toggleMobileMenu = () => {
    setIsActive(!isActive);
  };

  const closeMobileMenu = () => {
    setIsActive(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 150) {
        setScroll(true);
      } else {
        setScroll(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    const navLinks = document.querySelectorAll('.navbar-nav li a');
    navLinks.forEach((link) => {
      link.addEventListener('click', closeMobileMenu);
    });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      navLinks.forEach((link) => {
        link.removeEventListener('click', closeMobileMenu);
      });
    };
  }, []);

  return (
    <div className={`navBar ${scroll ? 'scrolled' : ''}`}>
      <nav className={`navbar navbar-area navbar-expand-lg navbar-area-3 ${scroll ? 'navbar-white' : ''}`}>
        <div className="container nav-container">
          <div className="responsive-mobile-menu">
            <button
              onClick={toggleMobileMenu}
              className={`menu toggle-btn d-block d-lg-none ${isActive ? 'open' : ''}`}
              data-target="#Iitechie_main_menu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-left"></span>
              <span className="icon-right"></span>
            </button>
          </div>
          <div className="logo">
            <a className="d-none d-lg-inline-block" href="/">
              <img src={logo_2} alt="logo" />
            </a>
            <a className="d-lg-none d-inline-block" href="/">
              <img src={logo_1} alt="logo" />
            </a>
          </div>
          <div className={`collapse navbar-collapse ${isActive ? 'sopen' : ''}`} id="Iitechie_main_menu">
            <ul className="navbar-nav menu-open text-lg-start">
              <NavMenu closeMobileMenu={closeMobileMenu} />
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
